import { format } from 'date-fns';
import { enUS, es } from 'date-fns/locale';
import React, { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import type { FormatDateProps, FormatDateWithi18nProps } from './types';

const formatDate = ({ date, locale = 'en' }: FormatDateProps): ReactElement | string => {
    const dateArray = date.split(' ');
    const dateEl = dateArray[2];

    const englishDate = () => {
        if (dateEl.length === 3) {
            const dateElArray = dateEl.split('');
            return (
                <>
                    {`${dateArray[0]}, ${dateArray[1]} ${dateElArray[0]}`}
                    <sup>{dateElArray[1] + dateElArray[2]}</sup>
                    {`, ${dateArray[3]}`}
                </>
            );
        }
        const dateElArray = dateEl.split('');
        return (
            <>
                {`${dateArray[0]}, ${dateArray[1]} ${dateElArray[0]}${dateElArray[1]}`}
                <sup>{dateElArray[2] + dateElArray[3]}</sup>
                {`, ${dateArray[3]}`}
            </>
        );
    };

    const spanishDate = () => `${dateArray[0]} ${dateArray[1]} ${dateArray[2]}, ${dateArray[3]}`;

    switch (locale) {
        case 'es-US':
            return spanishDate();
        default:
            return englishDate();
    }
};

const formatDateWithi18n = ({ value = Date.now() }: FormatDateWithi18nProps): ReactElement | string => {
    const { i18n } = useTranslation();

    let localeDate = enUS;
    let formatWithLocale = 'EEEE LLL do yyyy';
    if (i18n.language?.includes('es')) {
        localeDate = es;
        formatWithLocale = 'EEEE d LLL yyyy';
    }

    const date = format(new Date(value), formatWithLocale, { locale: localeDate });
    const locale = i18n.language;

    return formatDate({ date, locale });
};

export default formatDateWithi18n;
